import styled from 'styled-components';

export const LoadingContainer = styled.div`
  height: 100%;
`;
